import { useEffect, EffectCallback } from "react";

function useEffectOnMountOnly(callback: EffectCallback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
}

export default useEffectOnMountOnly;
